<script lang="ts">
  import ProductManagement from '../../../routes/ProductManagement.svelte';
</script>

<div class="p-3">
  <ProductManagement />
</div>
